import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as _ from 'lodash';
import { ModalDirective, ToastService } from 'ng-uikit-pro-standard';
import { FormatoProductosService } from 'src/app/services/formato-productos.service';
import { InventarioFisicoService } from 'src/app/services/inventario-fisico.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { FileDownloadService } from 'src/app/shared/services/file-download.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { SecurityService } from 'src/app/shared/services/security.service';

@Component({
  selector: 'app-modal-realizar-ajuste',
  templateUrl: './modal-realizar-ajuste.component.html',
  styleUrls: ['../exist-inventario-fisico.component.scss'],
  providers: [SecurityService],
})
export class ExistInventarioFisicoModalRealizarAjusteComponent implements OnInit {

  @Output() onSuccess: EventEmitter<void> = new EventEmitter<void>()

  @ViewChild('realizarAjuste', { static: true }) modalRealizarAjuste: ModalDirective;

  // Data & Tmp
  public rutEmpresa: number
  public sucursalCodigo: number

  // Form
  formDetails: FormGroup
  paginationContext: PaginationContext = new PaginationContext()
  loading: boolean = true
  processing: boolean = false;

  optionsFormato: any = []
  inventario_totales: any = null
  movimiento: any
  detalleDocumento: any[]
  detalleDocumentoAll: any[]
  checkAll: boolean = true

  filtros: {
    codigo: string
  } = { codigo: '' }

  // Utils
  private log: any

  constructor(
    private accesolocalstorage: SecurityService,
    private messageRendererService: MessageRendererService,
    private clog: ConsoleService,
    private toastService: ToastService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private formatoProductoService: FormatoProductosService,
    private inventarioFisicoService: InventarioFisicoService,
    private fileDownloadService: FileDownloadService,
  ) {
    this.log = this.clog.log('INVENTARIO/REALIZAR-AJUSTE')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa())
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo())
    this.createForms()
    this.formChangesSubscriptions()

    this.paginationContext.RecordsByPage = 10
  }

  createForms() {
    this.formDetails = this.fb.group({
      codigo: ['', [Validators.required]],
    })
  }

  formChangesSubscriptions() {
  }

  load(mov: any) {
    this.loading = true
    this.cleanUp()
    this.movimiento = mov
    this.loadInventarFisico(mov)
    this.modalRealizarAjuste.show()
  }

  cleanUp() {
    this.detalleDocumentoAll = null
    this.detalleDocumento = null
    this.formValidatorsService.reset(this.formDetails)
    this.formDetails.get('codigo').setValue('')
    this.checkAll = true
  }

  loadInventarFisico(mov) {
    const { rut_empresa, sucursal_codigo, codigo } = mov
    const inputParams = {
      entidad: {
        rut_empresa,
        sucursal_codigo,
        codigo,
      }
    }

    this.log('inputParams', JSON.stringify(inputParams))

    this.inventarioFisicoService.obtenerTomaInventario(inputParams, ({ respuesta, mensajes }) => {
      const ok = mensajes.filter(m => m.tipo === "ERROR").length === 0
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      const { detalleInventarioFisico } = respuesta

      this.paginationContext.RecordsCount = detalleInventarioFisico.length //totalRegistros
      this.paginationContext.PagesCount = Math.ceil(this.paginationContext.RecordsCount / this.paginationContext.RecordsByPage) //totalPaginas
      this.paginationContext.CurrentPage = 1 // paginaActual

      // details data
      detalleInventarioFisico.map((detalle, index) => {
        delete detalle.__typename
        detalle.additionalInfo = {
          checked: true,
          index
        }
      })

      this.detalleDocumentoAll = detalleInventarioFisico
      this.showPage(1)
      this.calculateTotales()
      this.loading = false
    })
  }

  calculateTotales() {
    this.inventario_totales = {
      cantidad: this.detalleDocumentoAll.length,
      total_dif: _.sumBy(this.detalleDocumentoAll, 'valor_dif'),
    }
  }

  showPage(pageNumber: number) {
    const documentBase = this.detalleDocumentoAll.filter(doc => doc.sku.includes(this.filtros.codigo))
    this.paginationContext.CurrentPage = pageNumber
    const start = (this.paginationContext.CurrentPage - 1) * this.paginationContext.RecordsByPage
    this.detalleDocumento = _.slice(documentBase, start, start + this.paginationContext.RecordsByPage)
  }

  onPageChange(context: PaginationContext) {
    this.showPage(context.RequestedPage)
  }

  filtrarProducto() {
    this.filtros.codigo = this.formDetails.get('codigo').value.trim()
    this.showPage(1)
  }

  checkAllChange({ checked }) {
    this.detalleDocumentoAll.forEach((detalle: any) => { detalle.additionalInfo.checked = checked })
    this.detalleDocumento.forEach((detalle: any) => { detalle.additionalInfo.checked = checked })
  }

  checkDetalle({ index, checked }) {
    this.log('index, checked', index, checked)

    const selectedMain: any = this.detalleDocumentoAll.filter((detalle: any) => detalle.additionalInfo.index === index)[0]
    selectedMain.additionalInfo.checked = !checked
    this.log('selectedMain', selectedMain)

    const selected: any = this.detalleDocumento.filter((detalle: any) => detalle.additionalInfo.index === index)[0]
    selected.additionalInfo.checked = !checked
    this.log('selected', selected)
  }

  eliminarProducto(index: number) {
    this.detalleDocumentoAll = this.detalleDocumentoAll.filter((detalle: any) => detalle.additionalInfo.index !== index)
    this.detalleDocumento = this.detalleDocumento.filter((detalle: any) => detalle.additionalInfo.index !== index)
    this.showPage(this.paginationContext.CurrentPage)
  }

  eliminarProductosSeleccionados() {
    this.detalleDocumentoAll = this.detalleDocumentoAll.filter((detalle: any) => !detalle.additionalInfo.checked)
    this.detalleDocumento = this.detalleDocumento.filter((detalle: any) => !detalle.additionalInfo.checked)
    this.showPage(this.paginationContext.CurrentPage)
  }

  guardar() {
    // let valid = this.formValidatorsService.validate(this.formDetails)

    // if (!this.detalleDocumento || this.detalleDocumento.length === 0) {
    //   this.toastService.error('Agregue producto(s)')
    //   valid = false
    // }

    // if (!valid)
    //   return

    this.processing = true;

    let detalle: any = _.cloneDeep(this.detalleDocumentoAll)
    this.log('detalle 1', detalle)
    detalle.map((doc: any) => {
      doc.seleccion = doc.additionalInfo.checked
    })


    this.log('detalle 2', detalle)
    // details data
    detalle.map((p, index) => {
      this.log(p)
      // delete p.__typename
      delete p.additionalInfo
      delete p.precio_costo
      delete p.valor_dif
    })

    const {
      rut_empresa, sucursal_codigo, codigo, rut_usuario_responsable, bodega_codigo,
      bodega_nombre, estado_inventario_codigo, observacion, no_inventariado, fecha_creacion, } = this.movimiento

    const inputParams = {
      entidad: {
        rut_empresa,
        sucursal_codigo,
        codigo,
        rut_usuario_responsable,
        bodega_codigo,
        bodega_nombre,
        estado_inventario_codigo,
        observacion,
        no_inventariado,
        fecha_creacion,
        detalleInventarioFisico: detalle
      }
    }

    this.log('inputParams', JSON.stringify(inputParams))

    this.inventarioFisicoService.guardarAjusteInventarioFisico(inputParams, ({ respuesta, mensajes }) => {
      this.processing = false;
      const ok = mensajes.filter(m => m.tipo === "ERROR").length === 0
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      this.onSuccess.emit()
      this.toastService.success('Operación exitosa')
      this.modalRealizarAjuste.hide()
    })
  }

  generarArchivoExcel() {
    const inputParams = {
      entidad: {
        rut_empresa: this.movimiento.rut_empresa,
        sucursal_codigo: this.movimiento.sucursal_codigo,
        codigo: this.movimiento.codigo
      }
    }

    this.log('inputParams', JSON.stringify(inputParams))

    this.inventarioFisicoService.excelDocInventarioFisico(inputParams, ({ respuesta, mensajes }) => {
      const ok = mensajes.filter(m => m.tipo === "ERROR").length === 0
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      const { rutaArchivo } = respuesta
      this.fileDownloadService.VerifyAndDownload(rutaArchivo)
    })
  }

}
